import { render, staticRenderFns } from "./viewLargeImage.vue?vue&type=template&id=33cf4d10&"
import script from "./viewLargeImage.vue?vue&type=script&lang=js&"
export * from "./viewLargeImage.vue?vue&type=script&lang=js&"
import style0 from "./viewLargeImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports